export default __webpack_public_path__ + "static/media/yoni-asia.d921a9ab.png";